module.exports = __webpack_public_path__ + "static/img/SPJY4.9295e2e1.png";